/* ============================================================
 * bundle-packs.js
 * Drives the Bundle Packs section.
 *  - Tabs show/hide one pack panel at a time (same behavior as the
 *    featured-products-collection-overlay section), with arrow-key
 *    support between tabs
 *  - "Add all to bundle" adds one of each product in the pack to the
 *    Bundle Builder (Products) section on the page through its
 *    root.bundleBuilderApi, flying each product image into the summary
 *  - If there's no Bundle Builder on the page, the button is hidden
 * ============================================================ */
(function () {
  'use strict';

  const initializedRoots = new WeakSet();

  function findBuilderApi() {
    const builder = document.querySelector('[data-bundle-builder-products]');
    return builder && builder.bundleBuilderApi ? builder.bundleBuilderApi : null;
  }

  function init(root) {
    if (initializedRoots.has(root)) return;
    initializedRoots.add(root);

    const tabs = Array.from(root.querySelectorAll('[data-bp-tab]'));
    const panels = Array.from(root.querySelectorAll('[data-bp-panel]'));
    const labels = {
      add: root.dataset.labelAdd || 'Add All to Bundle',
      added: root.dataset.labelAdded || 'Added to Your Bundle ✓',
      full: root.dataset.labelFull || 'Not enough room in your bundle (%room% left)',
      missing: root.dataset.labelMissing || "This pack isn't available right now",
      partial: root.dataset.labelPartial || "Some items in this pack aren't available, so they were skipped",
    };

    // ---- Tabs ----
    function activate(tab, focus) {
      const index = tab.dataset.bpTab;
      tabs.forEach((t) => {
        const active = t === tab;
        t.classList.toggle('is-active', active);
        t.setAttribute('aria-selected', active ? 'true' : 'false');
        t.tabIndex = active ? 0 : -1;
      });
      panels.forEach((panel) => {
        const active = panel.dataset.bpPanel === index;
        panel.classList.toggle('is-active', active);
        panel.hidden = !active;
      });
      if (focus) tab.focus();
    }

    tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => activate(tab, false));
      tab.addEventListener('keydown', (event) => {
        let next = null;
        if (event.key === 'ArrowRight') next = tabs[(i + 1) % tabs.length];
        if (event.key === 'ArrowLeft') next = tabs[(i - 1 + tabs.length) % tabs.length];
        if (event.key === 'Home') next = tabs[0];
        if (event.key === 'End') next = tabs[tabs.length - 1];
        if (!next) return;
        event.preventDefault();
        activate(next, true);
      });
    });

    // ---- Variant dropdowns ----
    // Switches which variant the card adds, and its price, photo and links.
    function syncProductToVariant(product, option) {
      product.dataset.variantId = option.value;
      const price = product.querySelector('[data-bp-product-price]');
      if (price && option.dataset.priceText) price.textContent = option.dataset.priceText;
      if (option.dataset.url) {
        product.querySelectorAll('[data-bp-product-link]').forEach((link) => {
          link.href = option.dataset.url;
        });
      }
      const image = product.querySelector('.bundle-packs__product-image');
      if (image && option.dataset.src && image.getAttribute('src') !== option.dataset.src) {
        image.srcset = option.dataset.srcset || '';
        image.src = option.dataset.src;
      }
    }

    root.addEventListener('change', (event) => {
      const select = event.target.closest('[data-bp-variant-select]');
      if (!select) return;
      const product = select.closest('[data-bp-product]');
      const option = select.selectedOptions[0];
      if (product && option) syncProductToVariant(product, option);
    });

    // A browser can restore a previous choice on reload; match the card to it.
    root.querySelectorAll('[data-bp-variant-select]').forEach((select) => {
      const product = select.closest('[data-bp-product]');
      if (product && select.selectedOptions[0]) syncProductToVariant(product, select.selectedOptions[0]);
    });

    // ---- Add all to bundle ----
    // Hidden when the page has no Bundle Builder to add to.
    const hasBuilder = !!document.querySelector('[data-bundle-builder-products]');
    root.querySelectorAll('[data-bp-add-all]').forEach((button) => {
      const wrap = button.closest('.bundle-packs__cta-wrap');
      if (!hasBuilder && wrap) wrap.hidden = true;
    });

    root.addEventListener('click', (event) => {
      const button = event.target.closest('[data-bp-add-all]');
      if (!button) return;
      const panel = button.closest('[data-bp-panel]');
      const statusEl = panel && panel.querySelector('[data-bp-status]');
      const labelEl = button.querySelector('[data-bp-cta-label]');
      const api = findBuilderApi();
      if (!panel || !api) return;

      const items = Array.from(panel.querySelectorAll('[data-bp-product]')).map((product) => ({
        id: product.dataset.variantId,
        sourceEl: product.querySelector('.bundle-packs__product-image'),
      }));
      const result = api.addVariants(items);

      let message = '';
      if (result.ok) {
        if (labelEl) labelEl.textContent = labels.added;
        button.classList.add('is-added');
        if (result.missing && result.missing.length) message = labels.partial;
      } else {
        if (labelEl) labelEl.textContent = labels.add;
        button.classList.remove('is-added');
        if (result.reason === 'full') message = labels.full.replace(/%room%/g, String(result.room));
        if (result.reason === 'missing') message = labels.missing;
      }
      if (statusEl) statusEl.textContent = message;

      // Per button, so another pack's click doesn't cancel this reset.
      clearTimeout(button._bpResetTimer);
      button._bpResetTimer = setTimeout(() => {
        if (labelEl) labelEl.textContent = labels.add;
        button.classList.remove('is-added');
        if (statusEl) statusEl.textContent = '';
      }, 2600);
    });
  }

  function boot() {
    document.querySelectorAll('[data-bundle-packs]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
